import type { ContentLang } from '../editorSlice'
import { messagesNow } from '@/i18n'
import { messages } from './messages'
import type { BlockIssue } from './publishBlockIssues'

export const LANG_CODE = { ru: 'RU', en: 'EN' } as const

/** Слот замера переполнения: блок на конкретном языке. */
export const overflowSlot = (blockId: number, lang: ContentLang): string => `${blockId}:${lang}`

type At = Pick<BlockIssue, 'lesson' | 'screen' | 'lessonId' | 'blockId'>

/**
 * Строка переполнения составного блока на языке. Красное (`over`) блокирует и
 * api не проверяется (`clientOnly`); жёлтое (`warn`) — рекомендация без блокировки.
 * Помещающийся блок строки не даёт.
 */
export const overflowRows = (
  at: At,
  overflow: ReadonlyMap<string, 'warn' | 'over'>,
  blockId: number,
  lang: ContentLang,
): BlockIssue[] => {
  const level = overflow.get(overflowSlot(blockId, lang))
  const m = messagesNow(messages)
  if (level === 'over') {
    return [{ ...at, problem: m.designOverflow, lang: LANG_CODE[lang], clientOnly: true }]
  }
  if (level === 'warn') {
    return [{ ...at, problem: m.designOverflowWarn, lang: LANG_CODE[lang], warning: true }]
  }
  return []
}

/** Замечания, из-за которых публикация закрыта: рекомендации (`warning`) не в счёт. */
export const blockingIssues = (issues: BlockIssue[]): BlockIssue[] =>
  issues.filter((i) => !i.warning)

/** Есть что заполнить: поля курса и уроков или блокирующие замечания экранов. */
export const isBlocking = (fieldCount: number, blocks: BlockIssue[]): boolean =>
  fieldCount > 0 || blockingIssues(blocks).length > 0
